<app-sale-invoice-grid
    [permissionKey]="'saleInvoices.list'"
    [filter]="['ThirdId.Id eq ' + element.Id]"
    (add)="onAddButtonClicked()"
    [canDelete]="true"
    [showPager]="false"
    [columns]="SaleInvoiceColumns"
></app-sale-invoice-grid>